import React, { Component } from "react";
import {Link} from "react-router-dom";
import {popupImages} from "./enrolling-componentpopup-images";
import './enrolling-component.css';
import Modal from 'react-modal';
import SLUGS from '../../resources/slugs'

class EnrollingComponent extends Component{
  
  constructor(props){
    super(props);
    this.state={
      showModal: false
    }
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleOpenModal () {
    this.setState({ showModal: true });
  }
  
  handleCloseModal () {
    this.setState({ showModal: false });
  }



  render(){
    return(
        <>
        <span onClick={this.handleOpenModal}>Earn $5 just for enrolling!</span>
         <Modal 
           isOpen={this.state.showModal}
           style={{
              overlay: {
                backgroundColor: 'rgba(29,32,38,0.9)'
              },
              content: {
                color: 'lightsteelblue',
                maxHeight: '242px',
                Height: 'auto',
                overflow: 'hidden' 
              }
            }}
          >
          <button onClick={this.handleCloseModal}><img src={popupImages.close_icon.url} alt=""/></button>
          <Link style={{
            fontWeight:600,
            fontSize:"12px",
            lineHeight:"15px",
            textAlign:"center",
            textTransform:"capitalize",
            color:"#006AFF",
            paddingLeft:"0",
            marginBottom:"6px"
          }} to={SLUGS.howitworks}>Earn $5 just for enrolling!</Link>
          <p style={{
            fontWeight:500,
            fontSize:'16px',
            lineHeight:'28px',
            textAlign:'center',
            color:'#5B6987',
            paddingBottom:'0'


          }}>
            When you complete enrollment and link an active payment account with Paypal, Payoneer or Stripe, a $5 Signup Bonus will be added to your Webtalk Wallet balance.
          </p>
        </Modal>
        </>
      )

  }
}

export default EnrollingComponent;